import { useMutation } from "@/compat/reactQuery";
import nonUserService from "../../services/nonUserService";

const useAddAnonymousAction = () => {
    return useMutation((formData) => nonUserService.addAction(formData));
}

export default useAddAnonymousAction;
